var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpades(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 25,
    viewBox: "0 0 31 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E7E2DE",
    fillRule: "evenodd",
    d: "M2.294 12.424L15.5 0l13.206 12.424C30.123 13.757 31 15.599 31 17.633 31 21.702 27.494 25 23.169 25c-3.78 0-6.934-2.52-7.669-5.87-.735 3.35-3.89 5.87-7.67 5.87C3.507 25 0 21.702 0 17.633c0-2.034.877-3.876 2.294-5.21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpades);
export default __webpack_public_path__ + "static/media/spades.178408513ff1d9f2a2f79b6905048737.svg";
export { ForwardRef as ReactComponent };